<div class="container" style="max-width: none;">

  <div class="header-container">
    <div class="logo-and-info">
      <img [src]="'../../assets/images/PSMFCLogo.png'" class="logo" />

      <div class="info">
        <div class="sub-block">
          <h3 style="font-size: 20px; font-weight: bold; color: var(--elog-brand-text)">Elog for {{dataSync.current_user().userName}}</h3>
        </div>
      </div>
    </div>

    <!-- Hamburger menu -->
    <div class="menu-button-container">
      <button mat-button [matMenuTriggerFor]="menu">
        <mat-icon class="menu-button" matBadgeSize="small" matBadge="priority_high" [matBadgeHidden]="!editedDeliveryId() && !editedTrawlDeliveryId() && !hasDraftTrips()" aria-hidden="false">menu</mat-icon>
      </button>
    </div>
  </div>



  <mat-menu #menu="matMenu" class="menu">

    <button *ngIf="dataSync.current_user().groundfishFishery || dataSync.current_user().trawlFishery" mat-menu-item
            (click)="router.navigate(['observer_report', selectedFishery() == 2 ? 'Trawl' : 'Groundfish'])">
      <mat-icon class="item-icon">visibility</mat-icon>
      <span class="menu-item">Observer Report</span>
    </button>

    <button *ngIf="dataSync.current_user().hmsFishery || dataSync.current_user().trawlFishery" mat-menu-item (click)="handleDraftClick()">
      <mat-icon class="item-icon">edit_document</mat-icon>
      <span class="menu-item" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <span>Draft Trips&nbsp;</span>
        <ng-container *ngIf="hasDraftTrips()">
          <mat-icon class="item-icon">error</mat-icon>
        </ng-container>
      </span>
    </button>

    <button mat-menu-item (click)="router.navigate(['deliveries_list'])">
      <mat-icon class="item-icon">folder</mat-icon>
      <span class="menu-item" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <span>Completed Deliveries&nbsp;</span>
        <ng-container *ngIf="editedDeliveryId() || editedTrawlDeliveryId()">
          <mat-icon class="item-icon">error</mat-icon>
        </ng-container>
      </span>
    </button>

    <button mat-menu-item
            (click)="router.navigate(['help_screen'])">
      <mat-icon class="item-icon">help</mat-icon>
      <span class="menu-item">Help</span>
    </button>

    <button mat-menu-item
            (click)="router.navigate(['profile'])">
      <mat-icon class="item-icon">person</mat-icon>
      <span class="menu-item">My Profile</span>
    </button>

    <button mat-menu-item
            (click)="router.navigate(['settings'])">
      <mat-icon class="item-icon">settings</mat-icon>
      <span class="menu-item">Settings</span>
    </button>

    <button mat-menu-item
            (click)="logout()">
      <mat-icon class="item-icon">logout</mat-icon>
      <span class="menu-item">Logout</span>
    </button>

  </mat-menu>

  <!-- Logbook Tabs -->
  <div *ngIf="dataSync.current_user().groundfishFishery && dataSync.current_user().hmsFishery" class="card-container">
    <mat-card [ngClass]="selectedFishery() == 0 ? 'card-selected' : 'card-normal'" (click)="selectedFishery.set(0)">
      <mat-card-content style="display: flex; justify-content: center;">Non-Trawl Groundfish</mat-card-content>
    </mat-card>
    <mat-card [ngClass]="selectedFishery() == 1 ? 'card-selected' : 'card-normal'" (click)="selectedFishery.set(1)">
      <mat-card-content style="display: flex; justify-content: center;">HMS</mat-card-content>
    </mat-card>
  </div>


  <div *ngIf="selectedFishery() != 0" style="margin-top: 20px; display: flex; flex-direction: column;">
    <form [formGroup]="landingForm">
      <mat-expansion-panel [expanded]="panelOpen()" (opened)="panelOpen.set(true)">
        <mat-expansion-panel-header>
          <mat-panel-title>@if (selectedFishery()==1) {HMS} @else {Trawl} Trip Information</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <mat-form-field>
            <mat-label>Departure Port</mat-label>
            <input matInput formControlName="departurePort" [matAutocomplete]="dept">
            <mat-autocomplete #dept="matAutocomplete">
              <mat-option *ngFor="let option of filteredDeparturePorts | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field>
            <mat-label>
              Departure Date@if (selectedFishery() != 1) { and Time}
            </mat-label>
            <input matInput readonly formControlName="departureDate" (click)="editDateTime()">
          </mat-form-field>
        </div>

        <div *ngIf="selectedFishery() == 2" style="display: flex; justify-content: space-around; align-items: baseline; border: 1px solid; border-radius: 5px;">
          <h3 style="font-weight: bold; font-size: large;">EM Trip?</h3>
          <mat-radio-group aria-label="Select an option" formControlName="isEMTrip">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false" style="padding-left: 25px;">No</mat-radio-button>
            </mat-radio-group>
        </div>
      </mat-expansion-panel>
    </form>
  </div>

  <div class="row" style= "margin-top: 25px">
    <mat-toolbar class="mat-toolbar-section"style="background-color: var(--elog-brand); color: var(--elog-brand-on); justify-content: space-between; border-bottom: 3px solid var(--elog-accent-strong)">
      <span *ngIf="selectedFishery() == 0">Open Logbook Sets</span>
      <span *ngIf="selectedFishery() == 1">Daily Fishing Log</span>
      <span *ngIf="selectedFishery() == 2">Open Logbook Hauls</span>

      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-spinner *ngIf="dataSync.sync_in_progress()" [diameter]="35" class="mat-spinner-color"></mat-spinner>

        <!-- Add In-Port Days (HMS only) -->
        <button *ngIf="selectedFishery() === 1"
                mat-mini-fab
                class="blue-icon-button"
                type="button"
                matTooltip="Add In-Port Days"
                matTooltipPosition="below"
                (click)="openInPortDialog()">
          <mat-icon>
            anchor
          </mat-icon>
        </button>

        <!-- Add Set -->
        <button mat-mini-fab
                class="blue-icon-button"
                type="button"
                matTooltip="Add Set"
                matTooltipPosition="below"
                (click)="handleAddSetClick()">
          <mat-icon>
            add
          </mat-icon>
        </button>
      </div>
    </mat-toolbar>

  </div>
    <div *ngIf="selectedFishery() == 0" style="display: flex; flex-direction: column; width: 100%">
      @for (set of groundfishSets(); track set.fishingEventID;) {

      <mat-card (click)="clickRow(set)" style="margin-top: 15px; background-color: var(--elog-card-bg);">
        <mat-card-header>
          <mat-card-title>Set {{set.setNumber}}</mat-card-title>
        </mat-card-header>
        <mat-card-content style="display: flex; flex-direction: column;">
          <span style="font-size: large; margin-top: 10px;" class="date">
            <b>Set:</b> {{ set.startDate | date:'MMM d, y, h:mm a' }}
          </span>
          <span style="font-size: large; margin-top: 10px;" class="date">
            <b>Retrieval:</b> {{ set.endDate | date:'MMM d, y, h:mm a' }}
          </span>
        </mat-card-content>
      </mat-card>

      }

      @if (groundfishSets().length == 0) {
        <div style="margin-top: 40px; display: flex; justify-content: center;">
          <h3 style="color: var(--elog-text-muted); font-style: italic;">
            No sets - Press + to add one.
          </h3>
        </div>   
      }
    </div>
    <div *ngIf="selectedFishery() == 1" style="display: flex; flex-direction: column; width: 100%">
      @for (set of hmsSets(); track set.fishingEventID;) {
      <mat-card (click)="clickRow(set)" style="margin-top: 15px; background-color: var(--elog-card-bg);">
        <mat-card-content style="display: flex; flex-direction: column;">
          <span style="font-size: large; margin-top: 10px;" class="date"><b>Fishing Date:</b> {{ set.startDate| date }}</span>
        </mat-card-content>
      </mat-card>

      }

      @if (hmsSets().length == 0) {
        <div style="margin-top: 40px; display: flex; justify-content: center;">
          <h3 style="color: var(--elog-text-muted); font-style: italic;">
            No sets - Press + to add one.
          </h3>
        </div>      
      }
    </div>
    <div *ngIf="selectedFishery() == 2" style="display: flex; flex-direction: column; width: 100%">
      @for (set of trawlSets(); track set.fishingEventID;) {
        <mat-card (click)="clickRow(set)" style="margin-top: 15px; background-color: var(--elog-card-bg);">
          <mat-card-content style="display: flex; flex-direction: column;">
            <span style="font-size: large; margin-top: 10px;" class="date">
              <b>Set:</b> {{ set.startDate | date:'MMM d, y, h:mm a' }}
            </span>
            <span style="font-size: large; margin-top: 10px;" class="date">
              <b>Retrieval:</b> {{ set.endDate | date:'MMM d, y, h:mm a' }}
            </span>
          </mat-card-content>
        </mat-card>

      }

      @if (trawlSets().length == 0) {
        <div style="margin-top: 40px; display: flex; justify-content: center;">
          <h3 style="color: var(--elog-text-muted); font-style: italic;">
            No sets - Press + to add one.
          </h3>
        </div>   
      }
    </div>


  <br>
  <br>
  <br>
  <br>
  <br>

</div>

<mat-toolbar class="toolbarNav">
  <div style="flex-grow: 1; display: flex; justify-content: space-between;">

    <!-- Set Summary -->
    <button mat-fab      
      class="secondary-button large-fab"  
      type="button"
      aria-label="Example icon button with a plus one icon"
      matTooltip="Summary"
      matTooltipPosition="above"
      (click)="router.navigate(['summary_report', 'menu', -1], { queryParams: { from: selectedFishery() } })">
      <mat-icon [inline]="true" style="font-size: 40px; line-height: 65px;">description</mat-icon>
    </button>

    <!-- Set Error -->
    <button *ngIf="SetErrorsLength > 0" mat-fab
      class="secondary-button large-fab"
      type="button"
      aria-label="Example icon button with a plus one icon"
      matTooltip="Errors/Warnings"
      matTooltipPosition="above"
      (click)="generateSetErrors()">
      <mat-icon [inline]="true" class="error-icon">
      @if (AnyErrors) {report} 
      @else {warning}
      </mat-icon>
    </button>


    <!-- Current Delivery -->
    <button mat-fab
      class="secondary-button"
      style="font-size: large; font-weight: bold;"
      type="button"
      aria-label="Delivery Button"
      matTooltip="View Current Delivery"
      matTooltipPosition="above"
      (click)="handleDeliveryClick()">
      <mat-icon [inline]="true" style="font-size: 40px; line-height: 65px;">drive_folder_upload</mat-icon>
    </button>
  </div>
   
</mat-toolbar>